import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { FastAverageColor } from "fast-average-color";
import Button from "@components/Button";
import Loader from "../Loader";
import { AnimatePresence, motion } from "framer-motion";
import useMeasure from "react-use-measure";
import { useWindowSize } from "../../Helpers";

const fac = new FastAverageColor();

export default function StoryComponent({
  img,
  video = false,
  currentIndexInGroup,
  setIsAssetReady,
  isStoryPaused,
  isCurrentGroup,
  isCurrentStory,
  customTime,
  buttons,
  closeStories,
}) {
  const [storyOverlayColor, setStoryOverLayColor] = useState("");
  const videoRef = useRef(null);
  const [internalAssetReady, setInternalAssetReady] = useState(false);

  useEffect(() => {
    if (isCurrentStory && internalAssetReady) {
      setIsAssetReady(true);
    }

    if (isStoryPaused) {
      videoRef.current?.pause();
    } else if (!isCurrentStory) {
      videoRef.current?.pause();

      if (videoRef.current?.currentTime) {
        videoRef.current.currentTime = 0;
      }
    } else {
      videoRef.current?.play();
      if (videoRef.current) {
        // setTimeout(() => setStoryOverLayColor(fac.getColor(videoRef.current)), 300);
      }
    }
  }, [isStoryPaused, currentIndexInGroup, isCurrentStory, internalAssetReady]);

  if (isCurrentStory) {
    customTime.current = videoRef.current?.duration ?? false;
  }

  return (
    <div className={`story-component`}>
      <div
        className="story-inner-overlay"
        style={{ backgroundColor: storyOverlayColor.rgba }}
      />

      {!internalAssetReady && (
        <Loader show={!internalAssetReady} blackBg={true} />
      )}

      <div className="main-content">
        {!!video ? (
          <video
            width="375"
            crossOrigin="anonymous"
            playsInline={true}
            muted={true}
            onLoadedData={(element) => {
              setInternalAssetReady(true);
            }}
            ref={videoRef}
            src={video}
          />
        ) : (
          <img
            crossOrigin="anonymous"
            src={img}
            alt="anonymous"
            {...(!isCurrentGroup && { loading: "lazy" })}
            onLoad={(element) => {
              setInternalAssetReady(true);
              // setStoryOverLayColor(fac.getColor(elemeft.target));
            }}
            className={`story-img`}
          />
        )}

        {!!buttons && (
          <div className="buttons">
            {buttons?.[0] && (
              <Button href={buttons?.[0]?.custom} action={() => closeStories()}>
                {buttons?.[0]?.metadata?.name}
              </Button>
            )}
            {buttons?.[1] && (
              <Button
                href={buttons?.[1]?.custom}
                action={() => closeStories()}
                btnClass="yellow outline"
              >
                {buttons?.[1]?.metadata?.name}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
